module.exports = __webpack_public_path__ + "img/hyundai-old.5f06f46b.jpg";